module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M0 0h48v48h-48v-48z\" fill=\"none\"/><path d=\"M12 8.728c-1.807 0-3.271 1.467-3.271 3.273s1.467 3.272 3.271 3.272 3.273-1.467 3.273-3.272c0-1.806-1.466-3.273-3.273-3.273zm-.001-.001c-1.807 0-3.271 1.467-3.271 3.273s1.467 3.272 3.271 3.272 3.273-1.467 3.273-3.272-1.466-3.273-3.273-3.273z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/dot.svg
// module id = 790
// module chunks = 1